import { gql, useMutation } from '@apollo/client'

import type { CartInfoInput, SyncCartResult } from '../types'

const INITIAL_SYNC_CARTS_MUTATION = gql`
  mutation InitialSyncCarts($carts: [CartInfoInput]!) {
    initialSyncCarts(carts: $carts) {
      id
      product_id
      amount
      shop_id
      delivery_cost
      usedPromocode
    }
  }
`

export interface InitialSyncCartsVariables {
  carts: CartInfoInput[]
}

export interface InitialSyncCartsResponse {
  initialSyncCarts: SyncCartResult[]
}

export function useMutateInitialSyncCarts () {
  return useMutation<InitialSyncCartsResponse, InitialSyncCartsVariables>(INITIAL_SYNC_CARTS_MUTATION)
}
